module.exports = __webpack_public_path__ + "img/digital08_mo.9496690a.jpg";